"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSetCountPerMuscleGroups = exports.calculateSetContributionsForMuscleGroups = exports.calculateSimplifiedMuscleSplit = exports.calculateSetContributionsForSimplifiedMuscleGroups = void 0;
const intersection_1 = __importDefault(require("lodash/intersection"));
const _1 = require(".");
const calculateSetContributionsForSimplifiedMuscleGroups = ({ muscle_group, other_muscles, }) => {
    const getContribution = (mg) => {
        if (mg.includes(muscle_group)) {
            return 1;
        }
        else if ((0, intersection_1.default)(mg, other_muscles).length) {
            return 0.5;
        }
        else if (muscle_group === 'full_body') {
            return 1 / 6;
        }
        return 0;
    };
    return {
        core: getContribution(_1.coreMuscles),
        shoulders: getContribution(_1.shoulderMuscles),
        arms: getContribution(_1.armMuscles),
        legs: getContribution(_1.legMuscles),
        back: getContribution(_1.backMuscles),
        chest: getContribution(_1.chestMuscles),
    };
};
exports.calculateSetContributionsForSimplifiedMuscleGroups = calculateSetContributionsForSimplifiedMuscleGroups;
const calculateSimplifiedMuscleSplit = ({ workoutsOrRoutines, includeWarmupSets, }) => {
    const totals = {
        core: 0,
        shoulders: 0,
        arms: 0,
        legs: 0,
        back: 0,
        chest: 0,
    };
    for (const workoutOrRoutine of workoutsOrRoutines) {
        for (const exercise of workoutOrRoutine.exercises) {
            const trimmedSets = includeWarmupSets
                ? exercise.sets
                : exercise.sets.filter((s) => s.indicator !== 'warmup');
            const setCount = trimmedSets.length;
            const contributions = (0, exports.calculateSetContributionsForSimplifiedMuscleGroups)({
                muscle_group: exercise.muscle_group,
                other_muscles: exercise.other_muscles,
            });
            totals.core += contributions.core * setCount;
            totals.shoulders += contributions.shoulders * setCount;
            totals.arms += contributions.arms * setCount;
            totals.legs += contributions.legs * setCount;
            totals.back += contributions.back * setCount;
            totals.chest += contributions.chest * setCount;
        }
    }
    return totals;
};
exports.calculateSimplifiedMuscleSplit = calculateSimplifiedMuscleSplit;
const calculateSetContributionsForMuscleGroups = ({ muscleGroup, otherMuscles, }) => {
    const getContribution = (mg) => {
        if (mg === muscleGroup) {
            return 1;
        }
        else if (otherMuscles.includes(mg)) {
            return 0.5;
        }
        return 0;
    };
    return _1.muscleGroups.reduce((acc, mg) => {
        acc[mg] = getContribution(mg);
        return acc;
    }, {});
};
exports.calculateSetContributionsForMuscleGroups = calculateSetContributionsForMuscleGroups;
const calculateSetCountPerMuscleGroups = ({ workoutsOrRoutines, includeWarmupSets, }) => {
    const totals = _1.muscleGroups.reduce((acc, muscleGroup) => {
        acc[muscleGroup] = 0;
        return acc;
    }, {});
    for (const workoutOrRoutine of workoutsOrRoutines) {
        for (const exercise of workoutOrRoutine.exercises) {
            const trimmedSets = includeWarmupSets
                ? exercise.sets
                : exercise.sets.filter((s) => s.indicator !== 'warmup');
            const setCount = trimmedSets.length;
            const contributions = (0, exports.calculateSetContributionsForMuscleGroups)({
                muscleGroup: exercise.muscle_group,
                otherMuscles: exercise.other_muscles,
            });
            for (const muscleGroup of _1.muscleGroups) {
                totals[muscleGroup] += contributions[muscleGroup] * setCount;
            }
        }
    }
    return totals;
};
exports.calculateSetCountPerMuscleGroups = calculateSetCountPerMuscleGroups;
